import React, { useState, useEffect } from "react";
import Grid from "components/UIComponents/Grid";
import { Column } from "devextreme-react/data-grid";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { taskSelected } from "features/service/updateRequestSlice";
import style from "./../Dashboard.module.scss";
import { Row } from "react-bootstrap";

const ReturnRequestsGrid = (props) => {
  const { t, i18n } = useTranslation("common");
  const history = useHistory();
  const [data, setData] = useState();
  const { user, clientProfiles } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    const getReturnRequestsList = async () => {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/PORTAL/CLIENTS/DASHBOARD/GET_CLIENT_DASHBOARD_RETURN_REQUESTS_LIST`,
        {
          Client_Profile_Id: clientProfiles?.Client_Profile_Id,
          PageIndex: "1",
          PageCount: "1000",
        },
        {
          headers: {
            Authorization: `Bearer ${user?.access_token}`,
          },
        }
      ).then(data => {
        setData(data.data.Data.Data)
        props.dataIsReady(false)
      })
    };
    getReturnRequestsList();
  }, []);

  let departmentName = "Department_Name_EN",
    serviceName = "Service_Name_EN",
    stepName = "Department_Service_Step_Name_EN",
    returnReason = "Request_Task_Title_Name_EN",
    RequestDesc = "Request_Desc_EN",
    areaName = "Area_Name_EN";

  if (i18n.language === "ar") {
    departmentName = "Department_Name_AR";
    serviceName = "Service_Name_AR";
    stepName = "Department_Service_Step_Name_AR";
    returnReason = "Request_Task_Title_Name_AR";
    areaName = "Area_Name_AR";
    RequestDesc = "Request_Desc_AR";
  }

  const handleEdit = (data) => {
    dispatch(taskSelected(data?.Task_Type_Id));
    history.push(`/update-request/${data?.Task_Type_Id}/${data?.Request_Id}/${data?.Request_Task_Id}`);
  };

  return (
    <>
      <Row className="justify-content-center">
        <p className={style.gridTitle}>{t("returned_requests")}</p>
      </Row>

      <Row>
        <Grid
          sourceData={data}
          addEnabled={false}
          editEnabled={true}
          deleteEnabled={false}
          viewEnabled={false}
          onEdit={({ data }) => handleEdit(data)}
        >
          <Column
            caption={t("request_no")}
            alignment="center"
            dataField="Request_No"
            dataType="string"
            width="auto"
          />
          <Column
            caption={t("request_date")}
            alignment="center"
            dataField="Request_Date"
            dataType="date"
            width="auto"
            format="yyyy-MM-dd"
          />
          <Column
            caption={t("service_name")}
            alignment="center"
            dataField={serviceName}
            dataType="string"
            width="auto"
          />
          <Column
            caption={t("department_name")}
            alignment="center"
            dataField={departmentName}
            dataType="string"
            width="auto"
            visible={false}
          />
          <Column
            caption={t("return_reason")}
            alignment="center"
            dataField={returnReason}
            dataType="string"
            width="auto"
          />
          <Column
            caption={t("request_stage")}
            alignment="center"
            dataField={stepName}
            dataType="string"
            width="auto"
          />
          <Column
            caption={t("requestDesc")}
            alignment="center"
            dataField={RequestDesc}
            dataType="string"
            width="auto"
          />
        </Grid>
      </Row>
    </>
  );
};

export default ReturnRequestsGrid;
